<script>
import ButtonNormal from '../../buttons/ButtonNormal.vue';
import { FileUploaderConfig } from '../../../models/FileUploaderModel';

export default {
    name: 'FileUploader',
        components: {
        ButtonNormal
    },
    props: {
        config: {
            type: FileUploaderConfig,
            required: true
        }
    },
    methods: {
        selectFile() {
            this.$refs.fileupload.click();
        },
        uploadFile(event) {
            this.$emit('uploadFile', event);
            this.$refs.fileupload.value = '';
        }
    }
};
</script>

<template>
    <div id="fileUploader">
        <div class="title">{{config.title}}</div>
        <span v-html="config.intro"></span>
        <div class="file" v-if="config.info.preFileText || config.info.fileName">{{config.info.preFileText}} <b>{{config.info.fileName}}</b></div>
        <div class="file-uploader-content-wrapper">
            <div class="upload-section">
                <input type="file" ref="fileupload" :accept="config.file.type" v-on:change="uploadFile($event)">
                <div class="file" @click="selectFile">
                    <img v-if="config.file.selected" src="@/assets/starface_icons_png/24/orange/tick.png" alt="File selected icon" />
                    <img v-else src="@/assets/starface_icons_png/24/grey/invoice_24.png" alt="File select icon" />
                    <span :class="{'orange':config.file.selected}" class="file-status"><b>{{config.file.selected ? "Ausgewählte Datei:" : "Datei auswählen:"}}</b></span>
                    <span class="file-name">{{config.file.selected ? config.info.selectedFile : "Klicke hier, um eine Datei auszuwählen"}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
#fileUploader {
    padding-bottom: 32px;
    .title {
        font-weight: bold;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px; 
        margin-bottom: 24px; 
    }
    .file {
        padding-top: 16px;
    }
    .file-uploader-content-wrapper {
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr 1fr;
        -ms-grid-columns: 1fr 1fr;
        gap: 48px;
        margin-top: 24px;
        .upload-section {
            grid-row: 1;
            -ms-grid-row: 1;
            grid-column: 1;
            -ms-grid-column: 1;
            letter-spacing: 0;
            line-height: 22px;
            input[type=file] {
                display: none
            }
            .file {
                display: flex;
                flex-direction: column;
                align-items: center;
                border: dashed 1px $orange;
                padding: 24px;
                text-align: center;
                background: #fff;
                cursor: pointer;
                img {
                    padding-bottom: 16px;
                }
                .file-status {
                    &.orange {
                        color: $orange;
                    }
                }
                .file-name {
                    font-size: 16px;
                    padding-top: 4px;
                    color:$orange;
                    text-decoration: underline;
                    width: 300px;
                    overflow:hidden; 
                    white-space:nowrap; 
                    text-overflow: ellipsis;
                }

                &:hover {
                    opacity: 0.6;
                }
            }
            .footer {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: 8px;
                .btn-upload {
                    width: 104px;
                    height: 34px;
                    &.disabled {
                        background: $grey-middle;
                        border-color: $grey-middle;
                    }
                }
            }
        }
    }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 600px) {
        .file-uploader-content-wrapper {
            grid-template-rows: auto;
            grid-template-columns: none;
            .upload-section {
                grid-row: 1;
                grid-column: 1;
            }
            .info-section {
                grid-row: 2;
                grid-column: 1;
            }
        }
    }
}
</style>